/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import { FormattedMessage } from '@modules/i18n'
import { colorForInstances } from '@modules/billing-lib/colorGenerator'

import {
  ColorKeyForOtherDeployments,
  ColorKeyForOtherProjects,
  ColorKeyForOtherCCM,
} from '@/components/Billing/BillingUsage/constants'

import type { RowType } from './types'

export const getLabel = (type: RowType) =>
  ({
    deployment: (
      <FormattedMessage
        id='billing-aggregation-row.all-deployments'
        defaultMessage='All other deployments'
      />
    ),
    project: (
      <FormattedMessage
        id='billing-aggregation-row.all-projects'
        defaultMessage='All other projects'
      />
    ),
    cloud_connect: (
      <FormattedMessage
        id='billing-aggregation-row.all-ccm'
        defaultMessage='All other connected clusters'
      />
    ),
  })[type]

export const getColor = (type: RowType) =>
  ({
    deployment: colorForInstances.get(ColorKeyForOtherDeployments),
    project: colorForInstances.get(ColorKeyForOtherProjects),
    cloud_connect: colorForInstances.get(ColorKeyForOtherCCM),
  })[type]
